import { render } from "./B2bPageOcrDocuments.vue?vue&type=template&id=458e0ce5&scoped=true&lang=pug"
import script from "./B2bPageOcrDocuments.vue?vue&type=script&lang=js"
export * from "./B2bPageOcrDocuments.vue?vue&type=script&lang=js"

import "./B2bPageOcrDocuments.vue?vue&type=style&index=0&id=458e0ce5&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-458e0ce5"]])

export default __exports__